import { Badge, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

const STATUSES = {
  new: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
    label: 'statistics::table.status.active',
  },
  active: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
    label: 'statistics::table.status.active',
  },
  archived: {
    icon: 'inbox-archive',
    color: 'Label-Fifth',
    bgColor: 'Background-Quaternary',
    label: 'statistics::table.status.archived',
  },
  paused: {
    icon: 'time-clock',
    color: 'Label-Notice',
    bgColor: 'Background-Notice',
    label: 'accounts_marketplace::category.list.badges.pending',
  },
  blocked: {
    icon: 'status warning',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'campaigns_editor::campaigns.table.badges.blocked',
  },
}

export const StatusBadge = ({ status = null, ...rest }) => {
  const currentStatus = STATUSES?.[status]
  const { t } = useTranslation()

  if (!currentStatus) {
    return null
  }

  const { icon, label, bgColor, color } = currentStatus

  return (
    <Badge
      {...rest}
      bgColor={bgColor}
      color={color}
      startIcon={
        <Icon
          color={color}
          name={icon}
          width={16}
        />
      }
    >
      {t(label)}
    </Badge>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType,
}
